import { HTMLAttributes, forwardRef } from 'react';

import { WithStyles, createStyles, withStyles } from '@material-ui/core';

import classNames from 'classnames';

const styles = createStyles({
  root: {
    display: 'inline-flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 'var(--bui-space-1)',
  },
});

export interface ExpressionRootProps
  extends HTMLAttributes<HTMLDivElement>,
    WithStyles<typeof styles> {}

const ExpressionRoot = forwardRef<HTMLDivElement, ExpressionRootProps>(
  (props, ref) => {
    const { classes, className, style, ...rest } = props;
    return (
      <div
        ref={ref}
        className={classNames(className, classes.root)}
        style={style}
        {...rest}
      />
    );
  },
);

ExpressionRoot.displayName = 'Expression.Root';

export default withStyles(styles)(ExpressionRoot);
